
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import CandidateV3Custom, {
  CandidateV3Item,
  CandidateV3RemarkReq
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3";

@Component({
  components: {}
})
export default class AddCandidateTags extends Vue {
  @Prop() selectedItem!: CandidateV3Item;
  @Prop({ default: false }) visible!: boolean;

  input = "";
  param = new CandidateV3RemarkReq();

  created() {
    this.param.candidateId = this.selectedItem.candidateId;
    this.input = this.selectedItem.remark;
  }

  submit() {
    this.param.remark = this.input;
    CandidateV3Custom.saveRemark(this.param).then(() => {
      this.$message.success("添加成功");
      this.sure();
    });
  }

  @Emit()
  cancel() {
    return true;
  }

  @Emit()
  sure() {
    return true;
  }
}
